import createIcon from '../../createIcon';

/**
 * @component @name Quickreply
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMy43NSAxNi42N1YzLjVIMTkuNzVWOS41SDIxLjc1VjMuNUMyMS43NSAyLjQgMjAuODUgMS41IDE5Ljc1IDEuNUgzLjc1QzIuNjUgMS41IDEuNzYgMi40IDEuNzYgMy41TDEuNzUgMjEuNUw1Ljc1IDE3LjVIMTQuNzVWMTUuNUg0LjkyTDMuNzUgMTYuNjdaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMjIuMjUgMTUuNUgyMC4wNUwyMS43NSAxMS41SDE2Ljc1VjE3LjVIMTguNzVWMjIuNUwyMi4yNSAxNS41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Quickreply = createIcon('Quickreply', [
  [
    'path',
    {
      d: 'M3.75 16.67V3.5H19.75V9.5H21.75V3.5C21.75 2.4 20.85 1.5 19.75 1.5H3.75C2.65 1.5 1.76 2.4 1.76 3.5L1.75 21.5L5.75 17.5H14.75V15.5H4.92L3.75 16.67Z',
      key: '60tp9s',
    },
  ],
  ['path', { d: 'M22.25 15.5H20.05L21.75 11.5H16.75V17.5H18.75V22.5L22.25 15.5Z', key: 'uhn0mm' }],
]);

export default Quickreply;
